import { render } from "./SiwaPage.vue?vue&type=template&id=e4785ca8&scoped=true"
import script from "./SiwaPage.vue?vue&type=script&lang=js"
export * from "./SiwaPage.vue?vue&type=script&lang=js"

import "./SiwaPage.vue?vue&type=style&index=0&id=e4785ca8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4785ca8"]])

export default __exports__